// UID: BWR-TAX_RTN_1Y-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2200
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
// Rules are separated by express/non-express loans. However, the rules are the same for both.

import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  IsBetweenMidAprilMidMay,
  IsBetweenMidAugMidOct,
  IsBetweenMidMayMidAug,
  RulesetResult,
  HasApplicantFiledTRLastYear,
  IsBetweenMidNovAndDec,
  IsBetweenMidOctMidNov,
  IsForProfit,
  IsBusinessEstablishedMoreThan,
} from '../rules';
import HasApplicantNotFiledTR from '../rules/HasApplicantNotFiledTR';

class TRLastYearRuleset implements Ruleset {
  private forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isBetweenMidOctAndDec = [
      IsBetweenMidOctMidNov,
      IsBetweenMidNovAndDec,
    ].some((Is) => Is.evaluate(data));

    const isBetweenMidAprilAndMidOct = [
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));

    const hasApplicantFiledTRLastYear =
      HasApplicantFiledTRLastYear.evaluate(data);
    const establishedMoreThanOneYearAgo =
      IsBusinessEstablishedMoreThan.setYears(1).evaluate(data);

    if (hasApplicantFiledTRLastYear) {
      // A) Is Between Mid April and Mid Oct && Has Applicant Filed TR Last Year
      if (isBetweenMidAprilAndMidOct) return RulesetResult.REQUIRED;
      // B) Is Between Mid Oct and Dec && Has Applicant Filed TR Last Year && Established More Than One Year Ago
      if (isBetweenMidOctAndDec && establishedMoreThanOneYearAgo)
        return RulesetResult.REQUIRED;
    }
    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);

    // If For Profit
    if (isForProfit) return this.forProfitResult(data);

    // If Not For Profit

    const isBetweenMidAprilAndMidOct = [
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));
    const isBetweenMidOctAndDec = [
      IsBetweenMidOctMidNov,
      IsBetweenMidNovAndDec,
    ].some((Is) => Is.evaluate(data));
    const hasApplicantFiledTRLastYear =
      HasApplicantFiledTRLastYear.evaluate(data);
    const hasApplicantNotFiledTR = HasApplicantNotFiledTR.evaluate(data);
    const isBetweenMidNovAndDec = IsBetweenMidNovAndDec.evaluate(data);

    // A) Between Mid April and Mid Oct && Has Applicant Filed TR Last Year
    if (isBetweenMidAprilAndMidOct && hasApplicantFiledTRLastYear)
      return RulesetResult.REQUIRED;
    // B) Between Mid Oct and Dec && Has Applicant Filed TR Last Year
    if (isBetweenMidOctAndDec && hasApplicantFiledTRLastYear)
      return RulesetResult.REQUIRED;
    // C) Between Mid Nov and Dec && Applicant Not Filed TR Last Year
    if (isBetweenMidNovAndDec && hasApplicantNotFiledTR)
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };
}

export default new TRLastYearRuleset();
